<template>
  <!--	노션 링크 : https://www.notion.so/Awards-Page-2f02096bf078442a88cbed9d616bda2c -->
  <div>
    <div>
      <breadcrumb :breadcrumb_link="awards_breadcrumb" />
    </div>

    <div class="header">
      <!--      <h1 class="overlay">GUIDE PROGRAM</h1>-->
      <!--      <img src="@/assets/images/Podohotel/about_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>

    <div class="contentDesc">
      <div class="title1">
        <h2>
          <strong>{{ $t('p_title') }}</strong>
        </h2>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-12" v-for="(item, index) in reversedItems" :key="index">
          <div class="row justify-content-center">
            <div class="card text-center mb-3" style="width: 22rem; height: 34rem">
              <div class="embed-responsive p-2">
                <img :src="item.thumb" class="card-img-top border" />
                <div class="card-body">
                  <h5 class="card-title" style="height: 3rem; line-height: 1.3rem">
                    {{ $t('items[' + (items.length - 1 - index) + '].title') }}
                  </h5>
                  <div class="card-footer">
                    <small class="text-muted">{{ $t('items[' + (items.length - 1 - index) + '].date') }}</small>
                  </div>
                  <p class="card-text text-left" style="line-height: 1.3rem">
                    <small v-html="$t('items[' + (items.length - 1 - index) + '].desc')"></small>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import SlideCarousels from '@/components/SlideCarousels';
import {VueperSlide} from 'vueperslides';

export default {
  name: 'AwardsPage',
  components: {Breadcrumb},
  data() {
    return {
      isModule: false,
      breakpoints: {
        992: {
          fixedHeight: 'auto',
          bullets: false,
          arrows: false,
          visibleSlides: 1,
          touchable: true,
          disableArrowsOnEdges: true,
        },
      },
      awards_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'ABOUT',
        present: this.$t('breadcrumb'),
      },
      items: [
        {
          id: 0,
          thumb: require('@/assets/images/Golf/awards_image_15.jpg'),
        },
        {
          id: 1,
          thumb: require('@/assets/images/Golf/awards_image_14.jpg'),
        },
        {
          id: 2,
          thumb: require('@/assets/images/Golf/awards_image_17.jpg'),
        },
        {
          id: 3,
          thumb: require('@/assets/images/Golf/awards_image_13.jpg'),
        },
        {
          id: 4,
          thumb: require('@/assets/images/Golf/awards_image_12.jpg'),
        },
        {
          id: 5,
          thumb: require('@/assets/images/Golf/awards_image_11.jpg'),
        },
        {
          id: 6,
          thumb: require('@/assets/images/Golf/awards_image_10.jpg'),
        },
        {
          id: 7,
          thumb: require('@/assets/images/Golf/awards_image_09.jpg'),
        },
        {
          id: 8,
          thumb: require('@/assets/images/Golf/awards_image_08.jpg'),
        },
        {
          id: 9,
          thumb: require('@/assets/images/Golf/awards_image_07.jpg'),
        },
        {
          id: 10,
          thumb: require('@/assets/images/Golf/awards_image_06.jpg'),
        },
        {
          id: 11,
          thumb: require('@/assets/images/Golf/awards_image_05.jpg'),
        },
        {
          id: 12,
          thumb: require('@/assets/images/Golf/awards_image_04.jpg'),
        },
        {
          id: 13,
          thumb: require('@/assets/images/Golf/awards_image_03.jpg'),
        },
        {
          id: 14,
          thumb: require('@/assets/images/Golf/awards_image_02.jpg'),
        },
        {
          id: 15,
          thumb: require('@/assets/images/Golf/awards_image_01.jpg'),
        },
        {
          id: 16,
          thumb: require('@/assets/images/Golf/awards_image_18.jpg'),
        },
        {
          id: 17,
          thumb: require('@/assets/images/Golf/awards_image_19.jpg'),
        },
        {
          id: 18,
          thumb: require('@/assets/images/Golf/awards_image_20.jpg'),
        },
        {
          id: 19,
          thumb: require('@/assets/images/Golf/awards_image_21.jpg'),
        },
        {
          id: 20,
          thumb: require('@/assets/images/Golf/awards_image_22.jpg'),
        },
        {
          id: 21,
          thumb: require('@/assets/images/Golf/awards_image_23.jpg'),
        },
        {
          id: 22,
          thumb: require('@/assets/images/Golf/awards_image_24.png'),
        },
        {
          id: 23,
          thumb: require('@/assets/images/Golf/awards_image_26.jpg'),
        },
        {
          id: 24,
          thumb: require('@/assets/images/Golf/awards_image_25.jpg'),
        },
      ],
      isLang: 0,
    };
  },
  computed: {
    reversedItems() {
      return this.items.slice().reverse();
    },
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }

      this.awards_breadcrumb = {
        toplink: 'HOME',
        prevlink: 'ABOUT',
        present: this.$t('breadcrumb'),
      };

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
  },
  mounted() {
    // this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    this.refreshLocale(this.$i18n.locale);
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
};
</script>

<style scoped lang="scss">
.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}

.contentDesc {
  text-align: center;

  .title1 {
    margin-top: 3rem;
    margin-bottom: 5rem;
  }

  .title2 {
    margin-top: 3rem;
  }

  .title3 {
    margin-top: 1rem;
    margin-bottom: 5rem;
  }
}

.sub_title {
  margin-top: 40px;
  margin-bottom: 50px;
}

.sub_background_image {
  background-image: url('~@/assets/images/Golf/awards_headerimage.png');
  background-color: #cccccc;
  height: 270px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.cardStyle {
  margin: 20px;
}

.card-columns {
  @media (min-width: 576px) {
    .card-columns {
      column-count: 2;
    }
  }

  @media (min-width: 768px) {
    .card-columns {
      column-count: 2;
    }
  }

  @media (min-width: 992px) {
    .card-columns {
      column-count: 3;
    }
  }

  @media (min-width: 1200px) {
    .card-columns {
      column-count: 3;
    }
  }
}

.card-footer {
  background-color: white;
  border: none;
}

h5,
p {
  word-break: keep-all;
}

.headerimage {
  width: 100%;
  margin: 0;
  content: url('~@/assets/images/Golf/awards_headerimage.png');
}

@media (min-width: 992px) {
  .card-img-top {
    width: 100%;
    height: 240px;
    object-fit: contain;
  }
}

@media (max-width: 1200px) {
  .card-img-top {
    width: 100%;
    height: 216px;
    object-fit: contain;
  }
}

@media (max-width: 992px) {
  .headerimage {
    display: none;
  }

  .card-img-top {
    width: 100%;
    height: 230px;
    object-fit: contain;
  }

  .header {
    //background-color: red;
    position: relative;
    width: 100%;
    padding-top: 5rem;
    > img {
      width: 100%;
    }

    .overlay {
      padding-top: 5rem;
      color: White;
      position: absolute;
      text-align: center;
      z-index: 12;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: lighter;
      letter-spacing: -0.1rem;
    }
  }
}
</style>
<i18n>
{
  "ko": {
    "breadcrumb": "어워즈",
    "p_title": "어워즈",
    "items": [
      {
        "id": 0,
        "title": "2005 세계 100대 골프 코스 선정",
        "desc": "미국 골프 다이제스트가 선정하는 미국을 제외한 세계 100대 골프코스에 핀크스GC가 한국 최초로 선정되었습니다.",
        "date": "2005.06"
      },
      {
        "id": 1,
        "title": "2005 세계 100대 골프 코스 선정",
        "desc": "47년의 오랜 역사를 지닌 영국 골프 전문 매거진 Golf World에서 선정하는 세계 100대 골프코스에 한국 최초로 선정되었습니다.",
        "date": "2005.11"
      },
      {
        "id": 2,
        "title": "2007 세계 100대 골프 코스 선정",
        "desc": "미국 골프 다이제스트가 선정하는 미국을 제외한 세계 100대 골프코스에 선정되었습니다.",
        "date": "2007.05"
      },
      {
        "id": 3,
        "title": "2010 ASIAN GOLF AWARDS 선정",
        "desc": "아시아, 태평양 지역에서 출간되는 골프 전문지 Asian Monthly Golf에서 선정하는 Best Course in Korea 부문에 선정되었습니다.",
        "date": "2010"
      },
      {
        "id": 4,
        "title": "골프 다이제스트 GOLF 부문 선정",
        "desc": "골프다이제스트 코리아에서 선정하는 2011-2012 대한민국 베스트 코스에 Gold 부문으로 선정되었습니다.",
        "date": "2011.05"
      },
      {
        "id": 5,
        "title": "2016 WORLD GOLF AWARDS 선정",
        "desc": "여행업계의 오스카상이라 불리며 세계적인 권위를 자랑하는 월드 골프 어워드에서 한국 베스트 골프코스로 선정되었습니다.",
        "date": "2016.11"
      },
      {
        "id": 6,
        "title": "2017 세계 100대 골프 리조트 선정",
        "desc": "유럽의 권위있는 골프 매거진 Great Golf Magazine의 2017 세계 100대 골프리조트에서 핀크스GC와 포도호텔이 가장 이국적인 리조트 부문에 선정되는 영광을 안았습니다.",
        "date": "2017.06"
      },
      {
        "id": 7,
        "title": "2017 한국 10대 홀 선정",
        "desc": "47년의 오랜 역사를 지닌 영국 골프 전문 매거진 Golf World에서 선정하는 세계 100대 골프코스에 한국 최초로 선정되었습니다.",
        "date": "2017.10"
      },
      {
        "id": 8,
        "title": "2017 한국 10대 코스 선정",
        "desc": "서울경제 골프매거진이 주최하며 2003년 개최부터 올해까지 핀크스GC가 총 6회 선정되었습니다.",
        "date": "2017.10"
      },
      {
        "id": 9,
        "title": "2018 클럽하우스 BEST 18 선정",
        "desc": "국내 최고의 주간 경제지 이코노미스트가 선정한 국내 골프장 클럽하우스 BEST 18’에 선정되었습니다.",
        "date": "2018.02"
      },
      {
        "id": 10,
        "title": "2018 한국 10대 골프클럽 레스토랑 선정",
        "desc": "서울경제 골프매거진이 주최하는 2018 TOP RESTAURANTS IN KOREA의 10대 레스토랑으로 선정 되었습니다.",
        "date": "2018.06"
      },
      {
        "id": 11,
        "title": "2018 WOLRD GOLF AWARD 선정",
        "desc": "여행업계의 오스카상이라 불리며 세계적인 권위를 자랑하는 월드 골프 어워드에서 2016년에 이어 2018년 한국 베스트 골프 코스로 선정되었습니다.",
        "date": "2018.11"
      },
      {
        "id": 12,
        "title": "2018 한국 10대 플래티넘 클럽 선정",
        "desc": "골프매거진이 주관하는 본 어워즈에서 회원혜택, 운영정책, 클럽문화, 국제적 명성 등의 기준에서 우수함을 인정받아 대한민국 톱10 플래티넘 클럽에 선정되었습니다.",
        "date": "2018.12"
      },
      {
        "id": 13,
        "title": "2019 한국 10대 코스 2위 선정",
        "desc": "서울경제 골프매거진이 주최하는 한국 10대 코스에서 아름다운 자연경관과 흥미로운 코스 설계 부문을 높게 평가 받아 2위에 선정되었습니다.",
        "date": "2019.11"
      },
      {
        "id": 14,
        "title": "2020 WORLD GOLF AWARD 선정",
        "desc": "여행업계의 오스카상이라 불리며 세계적인 권위를\n자랑하는 월드 골프 어워드에서 2016년, 2018년에 이어 2020년 한국 베스트 골프 코스로 선정되었습니다.",
        "date": "2020.11"
      },
      {
        "id": 15,
        "title": "2021 한국 10대 코스 1위 선정",
        "desc": "서울경제가 선정한 한국 10대 골프장에서 글로벌 수준의 국가대표 골프장으로 인정받으며 1위에 선정되었습니다.",
        "date": "2021.11"
      },
      {
        "id": 16,
        "title": "2022 WORLD GOLF AWARD 선정",
        "desc": "여행업계의 오스카상이라 불리며 세계적인 권위를 자랑하는 월드 골프 어워드에서 2016년, 2018년, 2020년에 이어 한국 베스트 골프 코스로 선정되었습니다.",
        "date": "2022.11"
      },
      {
        "id": 17,
        "title": "2023 한국 10대 코스 1위 선정",
        "desc": "서울경제가 선정한 한국 10대 골프장에서 글로벌 수준의 국가대표 골프장으로 인정받으며 1위에 선정되었습니다.",
        "date": "2023.12"
      },
      {
        "id": 18,
        "title": "2024 KPGA 제네시스 대상 수상",
        "desc": "올해 KPGA 대회가 개최된 22개 골프장 중에서 프로 및 경기위원, 협회관계자의 투표로 완벽한 코스와 그린 컨디션을 제공한 최상위 1곳 골프장에 주어지는 ‘올해의 토너먼트 코스’ 상에 수상했습니다.",
        "date": "2024.11"
      },
      {
        "id": 19,
        "title": "2024 WORLD GOLF AWARD 선정",
        "desc": "여행업계의 오스카상이라 불리며 세계적인 권위를 자랑하는 월드 골프 어워드에서 5회 연속 한국 베스트 골프 코스로 선정되었습니다.<br />(2016·2018·2020·2022·2024)",
        "date": "2024.11"
      },
      {
        "id": 20,
        "title": "2024 한국 10대 회원제 골프장 선정",
        "desc": "한국 10대 골프장 선정위원회와 서울경제 주최로 국내 최고 수준의 골프장을 발표하는 시상식에서 ‘2024 한국 10대 회원제 골프장’ 부문에 선정되었습니다.",
        "date": "2025.02"
      },
      {
        "id": 21,
        "title": "2025 한국 10대 골프장 선정",
        "desc": "서울경제와 한국 10대 골프장 선정위원회 81인이 뽑은 ‘2025 한국을 대표하는 10대 골프장’에 선정되었습니다.",
        "date": "2025.12"
      },
      {
        "id": 22,
        "title": "2025 한국골프관광협회 국내 '톱10 골프장' 선정",
        "desc": "한국골프관광협회가 주최하고 한국100대 골프코스 선정위원회와 다수의 국내 골프 전문 매체사 등이 공동 주관한 ‘한국100대 골프코스’에서 국내 '톱10 골프장'으로 선정되었습니다.",
        "date": "2026.01"
      },
      {
        "id": 23,
        "title": "2026 Top 100 Golf Course ASIA 선정",
        "desc": "골프트래블코리아와 골프트래블차이나가 공동 주관하는 ‘아시아 100대 골프장’ 평가에서 아시아 골프코스 순위 70위를 차지했습니다",
        "date": "2026.04"
      },
      {
        "id": 24,
        "title": "제4회 MK 대한민국 골프장 평가 ‘회원제 골프장 1위’ 선정",
        "desc": "매일경제와 한국리서치가 공동 진행한 2026 MK 대한민국 골프장 평가에서 10개 평가 항목 중 8개 부문에서 80점 이상 고득점으로 ‘최고 회원제 골프장 전국 1위’로 선정되었습니다.",
        "date": "2026.05"
      }
    ]
  },
  "en": {
    "breadcrumb": "Awards",
    "p_title": "Awards",
    "items": [
      {
        "id": 0,
        "title": "2005 Top 100 Golf Courses in the World",
        "desc": "PINX GC was selected as one of Top 100 Golf Courses in the World outside the USA for the first time in Korea by the Golf Digest of the USA",
        "date": "2005.06"
      },
      {
        "id": 1,
        "title": "2005 Top 100 Golf Courses in the World",
        "desc": "We were selected as one of the World’s 100 Golf Course selected by Golf World, the professional golf magazine of UK boasting 47 years of tradition.",
        "date": "2005.11"
      },
      {
        "id": 2,
        "title": "2007 Top 100 Golf Courses in the World",
        "desc": "We were selected as one of Top 100 Golf Courses in the World outside the USA by the Golf Digest of the USA.",
        "date": "2007.05"
      },
      {
        "id": 3,
        "title": "2010 ASIAN GOLF AWARDS",
        "desc": "We were selected as the Best Course in Korea by Asian Monthly Golf, the golf magazine published in Asian and Pacific region.",
        "date": "2010"
      },
      {
        "id": 4,
        "title": "The Gold category of the 2011-2012 Best Golf Course",
        "desc": "We were selected for the Gold category of the 2011-2012 Best Golf Course in Korea by Golf Digest Korea.",
        "date": "2011.05"
      },
      {
        "id": 5,
        "title": "2016 WORLD GOLF AWARDS",
        "desc": "We were selected as the best golf course in Korea at the World Golf Awards, which is referred to as the Oscar of the travel industry and boasts the worldwide authority",
        "date": "2016.11"
      },
      {
        "id": 6,
        "title": "2017 Top 100 Greatest Golf Resort",
        "desc": "PINX GC and PODO Hotel have been honored as one of the most exotic resort in the list of the Top 100 Golf Resorts in the World 2017 selected by Great Golf Magazine, the most prestigious golf magazine of Europe.",
        "date": "2017.06"
      },
      {
        "id": 7,
        "title": "2017 Top 10 Holes in Korea",
        "desc": "We were selected as one of the World’s 100 Golf Course selected by Golf World, the professional golf magazine of UK boasting 47 years of tradition.",
        "date": "2017.10"
      },
      {
        "id": 8,
        "title": "2017 Top 10 Course in Korea",
        "desc": "PINX GC has been selected six times as one of ‘TOP 10 COURSES IN KOREA’ from 2003 to this year, hosted by Seoul Economic Daily’s Golf Magazine.",
        "date": "2017.10"
      },
      {
        "id": 9,
        "title": "the 18 Best Golf Club House in Korea",
        "desc": "We were included in the 18 Best Golf Club House in Korea by the ‘Economist’, which is Korea’s best weekly business magazine.",
        "date": "2018.02"
      },
      {
        "id": 10,
        "title": "2018 Top 10 Restaurant in Korea",
        "desc": "We were included in the top 10 restaurants in ‘2018 TOP RESTAURANTS IN KOREA’ hosted by Seoul Economic Daily’s Golf Magazine.",
        "date": "2018.06"
      },
      {
        "id": 11,
        "title": "2018 WOLRD GOLF AWARD",
        "desc": "At the World Golf Awards, which is referred to as the Oscar of the travel industry and boasts the worldwide authority, PINX was selected as the best golf course in Korea in 2018 following the win in 2016.",
        "date": "2018.11"
      },
      {
        "id": 12,
        "title": "2018 The Best Private Membership Club in Korea",
        "desc": "We were included in ‘Korea’s Top 10 Platinum Club’ at this awards hosted by a golf magazine as our excellence was recognized for membership benefits, operating policy, club culture, and international reputation.",
        "date": "2018.12"
      },
      {
        "id": 13,
        "title": "Ranked 2nd ‘2019 Top 10 Course in Korea’",
        "desc": "Hosted by Seoul Economic Daily’s Golf Magazine in 「Top 10 Course in Korea」 It was ranked 2nd for its beautiful landscape and interesting course design.",
        "date": "2019.11"
      },
      {
        "id": 14,
        "title": "2020 WORLD GOLF AWARD",
        "desc": "At the World Golf Awards, which is referred to as the Oscar of the travel industry and boasts the worldwide authority, PINX was selected as the best golf course in Korea in 2020 following the win in 2016,2018.",
        "date": "2020.11"
      },
      {
        "id": 15,
        "title": "Selected as 1st in Korea’s Top 10 Courses in 2021",
        "desc": "Recognized as the world-class national golf course, PINX GC won the first place among top 10 golf courses in Korea selected by Seoul Economic Daily.",
        "date": "2021.11"
      },
      {
        "id": 16,
        "title": "2022 WORLD GOLF AWARD",
        "desc": "At the World Golf Awards, which is referred to as the Oscar of the travel industry and boasts the worldwide authority, PINX was selected as the best golf course in Korea in 2020 following the win in 2016,2018,2020",
        "date": "2022.11"
      },
      {
        "id": 17,
        "title": "2023 No.1 Course among\nKorea’s Top 10 Courses",
        "desc": "PINX Golf Club was ranked No.1 among Korea’s top 10 golf courses by Seoul Economy Daily newspaper.",
        "date": "2023.12"
      },
      {
        "id": 18,
        "title": "2024 KPGA Genesis Awards Best\nTournament Course of the Year",
        "desc": "Voted by professionals and association officials, PINX Golf Club was awarded the ‘Best Tournament Course of the Year’ among the 22 golf courses that has hosted 2024 KPGA tournaments for providing the best course and green conditions.",
        "date": "2024.11"
      },
      {
        "id": 19,
        "title": "2024 WORLD GOLF AWARDS\nBest Golf Course in Korea",
        "desc": "PINX Golf Club has been selected as the Best Golf Course in Korea for 5 consecutive times by the World Golf Awards, also known as the Oscars of the travel industry.<br />(2016·2018·2020·2022·2024)",
        "date": "2024.11"
      },
      {
        "id": 20,
        "title": "2024 Top 10 Private Clubs in Korea",
        "desc": "Pinx Golf Club was honored to be selected as one of the ‘2024 Top 10 Private Clubs in Korea.’ The award was presented at a ceremony that recognizes the nation’s top golf courses, hosted by the Korea’s Top 10 Golf Course Selection Committee and the Seoul Economic Daily",
        "date": "2025.02"
      },
      {
        "id": 21,
        "title": "2025 Top 10 Golf Courses in Korea",
        "desc": "Pinx Golf Club was honored to be selected as one of the '2025 Top 10 Golf Courses in Korea.' The selection was voted on by an 81-member panel from the Korea's Top 10 Golf Course Selection Committee and the Seoul Economic Daily.",
        "date": "2025.12"
      },
      {
        "id": 22,
        "title": "2025 'Top 10 Golf Courses in Korea' by Korea Golf Travel Association",
        "desc": "Pinx Golf Club has been selected as one of the 'Top 10 Golf Courses in Korea' in the Top 100 Golf Courses evaluation. This prestigious recognition was hosted by the Korea Golf Travel Association and co-organized by the Top 100 Golf Courses in Korea Selection Committee and multiple domestic golf media outlets.",
        "date": "2026.01"
      },
      {
        "id": 23,
        "title": "2026 Top 100 Golf Courses in Asia",
        "desc": "Pinx Golf Club was ranked 70th overall in the ‘Top 100 Golf Courses in Asia’ evaluation. This prestigious ranking was jointly organized by Golf Travel Korea and Golf Travel China.",
        "date": "2026.04"
      },
      {
        "id": 24,
        "title": "4th MK Korea Golf Course Evaluation: 'No. 1 Private Golf Course'",
        "desc": "In the 2026 MK Korea Golf Course Evaluation, jointly conducted by Maeil Business Newspaper and Hankook Research, Pinx Golf Club was awarded the 'No. 1 Private Golf Course in Korea.' The club achieved outstanding results, scoring 80 points or higher in 8 out of the 10 evaluation categories.",
        "date": "2026.05"
      }
    ]
  },
  "ja": {
    "breadcrumb": "アワーズ",
    "p_title": "Awards",
    "items": [
      {
        "id": 0,
        "title": "2005 세계 100대 골프 코스 선정",
        "desc": "미국 골프 다이제스트가 선정하는 미국을 제외한 세계 100대 골프코스에 핀크스GC가 한국 최초로 선정되었습니다.",
        "date": "2005.06"
      },
      {
        "id": 1,
        "title": "2005 세계 100대 골프 코스 선정",
        "desc": "47년의 오랜 역사를 지닌 영국 골프 전문 매거진 Golf World에서 선정하는 세계 100대 골프코스에 한국 최초로 선정되었습니다.",
        "date": "2005.11"
      },
      {
        "id": 2,
        "title": "2007 세계 100대 골프 코스 선정",
        "desc": "미국 골프 다이제스트가 선정하는 미국을 제외한 세계 100대 골프코스에 선정되었습니다.",
        "date": "2007.05"
      },
      {
        "id": 3,
        "title": "2010 ASIAN GOLF AWARDS 선정",
        "desc": "아시아, 태평양 지역에서 출간되는 골프 전문지 Asian Monthly Golf에서 선정하는 Best Course in Korea 부문에 선정되었습니다.",
        "date": "2010"
      },
      {
        "id": 4,
        "title": "골프 다이제스트 GOLF 부문 선정",
        "desc": "골프다이제스트 코리아에서 선정하는 2011-2012 대한민국 베스트 코스에 Gold 부문으로 선정되었습니다.",
        "date": "2011.05"
      },
      {
        "id": 5,
        "title": "2016 WORLD GOLF AWARDS 선정",
        "desc": "여행업계의 오스카상이라 불리며 세계적인 권위를 자랑하는 월드 골프 어워드에서 한국 베스트 골프코스로 선정되었습니다.",
        "date": "2016.11"
      },
      {
        "id": 6,
        "title": "2017 세계 100대 골프 리조트 선정",
        "desc": "유럽의 권위있는 골프 매거진 Great Golf Magazine의 2017 세계 100대 골프리조트에서 핀크스GC와 포도호텔이 가장 이국적인 리조트 부문에 선정되는 영광을 안았습니다.",
        "date": "2017.06"
      },
      {
        "id": 7,
        "title": "2017 한국 10대 홀 선정",
        "desc": "47년의 오랜 역사를 지닌 영국 골프 전문 매거진 Golf World에서 선정하는 세계 100대 골프코스에 한국 최초로 선정되었습니다.",
        "date": "2017.10"
      },
      {
        "id": 8,
        "title": "2017 한국 10대 코스 선정",
        "desc": "서울경제 골프매거진이 주최하며 2003년 개최부터 올해까지 핀크스GC가 총 6회 선정되었습니다.",
        "date": "2017.10"
      },
      {
        "id": 9,
        "title": "2018 클럽하우스 BEST 18 선정",
        "desc": "국내 최고의 주간 경제지 이코노미스트가 선정한 국내 골프장 클럽하우스 BEST 18’에 선정되었습니다.",
        "date": "2018.02"
      },
      {
        "id": 10,
        "title": "2018 한국 10대 골프클럽 레스토랑 선정",
        "desc": "서울경제 골프매거진이 주최하는 2018 TOP RESTAURANTS IN KOREA의 10대 레스토랑으로 선정 되었습니다.",
        "date": "2018.06"
      },
      {
        "id": 11,
        "title": "2018 WOLRD GOLF AWARD 선정",
        "desc": "여행업계의 오스카상이라 불리며 세계적인 권위를 자랑하는 월드 골프 어워드에서 2016년에 이어 2018년 한국 베스트 골프 코스로 선정되었습니다.",
        "date": "2018.11"
      },
      {
        "id": 12,
        "title": "2018 한국 10대 플래티넘 클럽 선정",
        "desc": "골프매거진이 주관하는 본 어워즈에서 회원혜택, 운영정책, 클럽문화, 국제적 명성 등의 기준에서 우수함을 인정받아 대한민국 톱10 플래티넘 클럽에 선정되었습니다.",
        "date": "2018.12"
      },
      {
        "id": 13,
        "title": "2019 한국 10대 코스 2위 선정",
        "desc": "서울경제 골프매거진이 주최하는 한국 10대 코스에서 아름다운 자연경관과 흥미로운 코스 설계 부문을 높게 평가 받아 2위에 선정되었습니다.",
        "date": "2019.11"
      },
      {
        "id": 14,
        "title": "2020 WORLD GOLF AWARD 선정",
        "desc": "여행업계의 오스카상이라 불리며 세계적인 권위를\n자랑하는 월드 골프 어워드에서 2016년, 2018년에 이어 2020년 한국 베스트 골프 코스로 선정되었습니다.",
        "date": "2020.11"
      },
      {
        "id": 15,
        "title": "2021 한국 10대 코스 1위 선정",
        "desc": "서울경제가 선정한 한국 10대 골프장에서 글로벌 수준의 국가대표 골프장으로 인정받으며 1위에 선정되었습니다.",
        "date": "2021.11"
      },
      {
        "id": 16,
        "title": "2022 WORLD GOLF AWARD 선정",
        "desc": "여행업계의 오스카상이라 불리며 세계적인 권위를 자랑하는 월드 골프 어워드에서 2016년, 2018년, 2020년에 이어 한국 베스트 골프 코스로 선정되었습니다.",
        "date": "2022.11"
      },
      {
        "id": 17,
        "title": "2023 한국 10대 코스 1위 선정",
        "desc": "서울경제가 선정한 한국 10대 골프장에서 글로벌 수준의 국가대표 골프장으로 인정받으며 1위에 선정되었습니다.",
        "date": "2023.12"
      },
      {
        "id": 18,
        "title": "2024 KPGA 제네시스 대상 수상",
        "desc": "올해 KPGA 대회가 개최된 22개 골프장 중에서 프로 및 경기위원, 협회관계자의 투표로 완벽한 코스와 그린 컨디션을 제공한 최상위 1곳 골프장에 주어지는 ‘올해의 토너먼트 코스’ 상에 수상했습니다.",
        "date": "2024.11"
      },
      {
        "id": 19,
        "title": "2024 WORLD GOLF AWARD 선정",
        "desc": "여행업계의 오스카상이라 불리며 세계적인 권위를 자랑하는 월드 골프 어워드에서 5회 연속 한국 베스트 골프 코스로 선정되었습니다.<br />(2016·2018·2020·2022·2024)",
        "date": "2024.11"
      },
      {
        "id": 20,
        "title": "2024 한국 10대 회원제 골프장 선정",
        "desc": "한국 10대 골프장 선정위원회와 서울경제 주최로 국내 최고 수준의 골프장을 발표하는 시상식에서 ‘2024 한국 10대 회원제 골프장’ 부문에 선정되었습니다.",
        "date": "2025.02"
      },
      {
        "id": 21,
        "title": "2025 한국 10대 골프장 선정",
        "desc": "서울경제와 한국 10대 골프장 선정위원회 81인이 뽑은 ‘2025 한국을 대표하는 10대 골프장’에 선정되었습니다.",
        "date": "2025.12"
      },
      {
        "id": 22,
        "title": "2025 한국골프관광협회 국내 '톱10 골프장' 선정",
        "desc": "한국골프관광협회가 주최하고 한국100대 골프코스 선정위원회와 다수의 국내 골프 전문 매체사 등이 공동 주관한 ‘한국100대 골프코스’에서 국내 '톱10 골프장'으로 선정되었습니다.",
        "date": "2026.01"
      },
      {
        "id": 23,
        "title": "제4회 MK 대한민국 골프장 평가 ‘회원제 골프장 1위’ 선정",
        "desc": "매일경제와 한국리서치가 공동 진행한 2026 MK 대한민국 골프장 평가에서 10개 평가 항목 중 8개 부문에서 80점 이상 고득점으로 ‘최고 회원제 골프장 전국 1위’로 선정되었습니다.",
        "date": "2026.05"
      }
    ]
  }
}
</i18n>
